import { Pipe, PipeTransform } from '@angular/core';
import { OverviewListItem } from '../data/overview-list-item';

@Pipe({
  name: 'formsSearch',
  standalone: true
})
export class FormsSearchPipe implements PipeTransform {
  transform(items: OverviewListItem[], cat: string | undefined, search: string): OverviewListItem[] {
    if (!items) {
      return items;
    }
    if (search && search.length >= 2) {
      return items.filter(
        item => item.name?.toLowerCase().replace(' ', '').replace('-', '').trim()
          .includes(search.toLowerCase().replace(' ', '').replace('-', '').trim())
      );
    } else {
      return items.filter(item => item.groupName === cat);
    }
  }
}
